// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Default_wrapper__gIegj","btnWrapper":"Default_btnWrapper__xIG0h","btn":"Default_btn__7TLBz","contentWrapper":"Default_contentWrapper__7TyjN"};